module.exports = __webpack_public_path__ + "img/sc@2x.9cfdc02c.png";